import React, { useState, useEffect } from "react";
import { createPopper } from "@popperjs/core";
import { useHistory } from "react-router";
import toast, { Toaster } from 'react-hot-toast';

// API
import { authLogout } from "views/auth/login/api/loginAPI";
// import { faLinkSlash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { resetUserLogin } from "app/GlobalSlice";



const UserDropdown = () => {

  const history = useHistory();
  // const dispatch = useDispatch();

  const userLogin = useSelector(state => state.global.userLogin)

  // console.log(userLogin.image_profile);
  const [isLoading, setIsLoading] = useState(false);

  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  // Loading
  useEffect(() => {
    if(isLoading === true) {
        toast.loading("Data Diproses...");
    }
  }, [isLoading])

  // Handle when User Click Logout Button
  const handleLogout = (e) => {
    e.preventDefault();
    setIsLoading(true);

    authLogout()
    .then((response) => { setResult(response) })
    .catch((err) => setErrors(err))
    .finally(setIsLoading(false));
  }

  // Check if Request Failed 
  useEffect(() => {
    if(errors !== null) {
        toast.error(errors.message);
    }
  }, [errors])  

   // Check if Request Success
   useEffect(() => {
      if(result !== null) {
          if(result.data.success === true) {
              toast.success(result.data.message);
              // dispatch(resetUserLogin());
              // setIsLoggedIn(false);
              history.push('/auth');
          } else {
              let numericArray = [];
              for (let err in result.data.errors) {
                  numericArray.push(result.data.errors[err])
              }
              numericArray.forEach((err) => {
                  toast.error(err);
              })
          }
      }
    }, [history, result])

  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };




  return (
    <>
      <Toaster />
      <a
        className="text-blueGray-500 block"
        href="#alc"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            <img
              alt="..."
              className="w-full rounded-full align-middle border-none shadow-lg"
              src={userLogin.image_profile ? userLogin.image_profile : require("assets/img/alc.png").default}
            />
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
        {/* <a
          href="#alc"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          {emailUser}
        </a> */}
        {/* <a
          href="#alc"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          Another action
        </a> */}
        <Link
          to="/setting/changePassword"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
        >
          Change Password
        </Link>
        <div className="h-0 my-2 border border-solid border-blueGray-100" />
        <a
          href="#alc"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={handleLogout}
        >
          Logout
        </a>
      </div>
    </>
  );
};

export default UserDropdown;
